import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useDirectDealsPublisherDetails } from '../../utils/context/DirectDealsPublisherDetailsContext.tsx';
import { DynamicValueSectionItems } from './parts/DynamicValueSectionItems.tsx';

export const MoreInfoSection = () => {
  const { t } = useTranslation();
  const publisherDetails = useDirectDealsPublisherDetails();

  const allSectionItemsMissing =
    !publisherDetails?.website_url && !publisherDetails?.media_kit_url && !publisherDetails?.other_info;

  if (!publisherDetails || allSectionItemsMissing) {
    return null;
  }

  return (
    <Grid
      container
      sx={{
        padding: 3,
        marginTop: 2,
        borderBottom: 1,
        borderColor: 'divider',
        width: 1,
      }}
    >
      <Grid size={3}>
        <Typography data-test="more-info-section" variant="h1">
          {t('More info')}
        </Typography>
      </Grid>

      <Grid size={6}>
        <DynamicValueSectionItems
          item={publisherDetails}
          props={['website_url', 'media_kit_url', 'other_info']}
          propNameMap={{
            website_url: t('URL'),
            media_kit_url: t('Media Kit'),
          }}
        />
      </Grid>
      <Divider />
    </Grid>
  );
};
